(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tr-inspired-browse"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tr-inspired-browse')) {
  customElements.define('tr-inspired-browse', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const activate = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          this.querySelector('#' + CSS.escape(item.getAttribute('aria-controls'))).hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-sales-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tr-sales-slider'))customElements.define('tr-sales-slider',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.slides=Array.from(this.querySelectorAll('.tr-sales__slide'));this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;const pause=this.querySelector('[data-pause]');const updatePause=()=>{pause.textContent=this.querySelector(this.paused?'[data-play-label]':'[data-pause-label]').textContent;pause.setAttribute('aria-pressed',String(this.paused));};this.show=(i)=>{this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>s.hidden=n!==this.index);this.querySelector('[data-count]').textContent=(this.index+1)+' / '+this.slides.length;};this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1));this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1));pause.addEventListener('click',()=>{this.paused=!this.paused;updatePause();});this.addEventListener('pointerenter',()=>this.hovered=true);this.addEventListener('pointerleave',()=>this.hovered=false);this.addEventListener('focusin',()=>this.focused=true);this.addEventListener('focusout',()=>this.focused=false);this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden)this.show(this.index+1);},8000);updatePause();}
disconnectedCallback(){clearInterval(this.timer);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();
})();
